<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="登录地址">
              <a-input placeholder="请输入" v-model="queryParams.ipaddr"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="用户名称">
              <a-input placeholder="请输入" v-model="queryParams.userName"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- <a-card :bordered="false" class="content"> -->

        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.ONLINE_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="indexId" slot-scope="{index}">
            {{ index+1 }}
          </span>
          <span slot="loginTime" slot-scope="{record}">
            {{ parseTime(record.loginTime) }}
          </span>

          <span slot="action" slot-scope="{record}">
            <a @click="handleForceLogout(record)" v-hasPermi="['monitor:online:forceLogout']">强退</a>
          </span>
        </ls-api-table>
      <!-- 底部分页按钮 -->
        <!-- </a-card> -->
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { list, forceLogout } from '@/api/monitor/online'
import { generateLsTableResData } from '@/utils/util.js';
export default {
  name: 'Online',
  data () {
    return {
             // 表格配置
     tableProps: {
        requestApi: generateLsTableResData(list, true),
        pageCurrent: true
      },
      // 分页数据(默认第一页):
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      current: 1,
      pageSize: 10,
      total: 0,
      // 表格等待
      tableLoading: false,
      // 表格数据
      list: [],
      // 查询参数
      queryParams: {
        ipaddr: undefined,
        userName: undefined
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'indexId',
          scopedSlots: { customRender: 'indexId' },
          align: 'center'
        },
        {
          title: '会话编号',
          dataIndex: 'tokenId',
          align: 'center',
          ellipsis: true
        },
        {
          title: '登录名称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '主机',
          dataIndex: 'ipaddr',
          scopedSlots: { customRender: 'ipaddr' },
          align: 'center'
        },
        {
          title: '登录时间',
          dataIndex: 'loginTime',
          scopedSlots: { customRender: 'loginTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    this.onSearch();
  },
  methods: {
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
       this.$refs.dataTable.getData();
    },
    /** 查询登录日志列表 */
    getList () {
      this.tableLoading = true
      list(this.queryParams).then(response => {
        this.list = response.rows
        this.total = response.total
        this.tableLoading = false
        this.list = this.list.map((item, index) => {
            return Object.assign(item, { 'indexId': (index + 1) })
        })
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.current = 1
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        ipaddr: undefined,
        userName: undefined
      }
      this.handleQuery()
    },
    /** 强退按钮操作 */
    handleForceLogout (row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `是否确认强退名称为${row.userName}的用户?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          forceLogout(row.tokenId).then(response => {
            if (response.code === 200) {
              self.$message.success('强退成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    }
  }
}
</script>
